import { render, staticRenderFns } from "./ToolbarApps.vue?vue&type=template&id=3a22b684&scoped=true&"
import script from "./ToolbarApps.vue?vue&type=script&lang=js&"
export * from "./ToolbarApps.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarApps.vue?vue&type=style&index=0&id=3a22b684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22b684",
  null
  
)

export default component.exports